<div
    class="progress-modal"
  >
    <div *ngIf="isLoading; else progressDetails" class="loading">
      <nz-spin nzSimple></nz-spin>
    </div>

    <ng-template #progressDetails>
      <header class="progress-modal__header">
        <h2 class="progress-modal__student">{{ userProgress?.userName }}</h2>
        <p class="progress-modal__course">{{ userProgress?.courseName }}</p>
      </header>

      <div class="progress-modal__body">
        <section
          class="progress-group"
          *ngFor="let module of userProgress?.modules"
        >
          <h3 class="progress-group__title">{{ module.moduleName }}</h3>

          <ul class="progress-list">
            <li
              class="progress-list__row"
              *ngFor="let lesson of module.items"
              (click)="redirectToLessonOrQuiz(lesson)"
            >
              <span class="progress-list__label">{{ lesson.name }}</span>
              <span class="progress-badge" [ngClass]="statusClass(lesson.status, lesson.type)">
                {{ lesson.grade ? 'Nota: ' + lesson.grade : lesson.status }}
              </span>
            </li>
          </ul>
        </section>
      </div>

      <footer class="progress-modal__footer">
        <button
          type="button"
          nbButton
          (click)="close()"
          class="uni--secondary-button"
          i18n="Botao | botao pra fechar a modal de progressos do curso"
        >
          Fechar
        </button>
      </footer>
    </ng-template>
  </div>